// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"672":"0f5fadeb","702":"dd5eac4e"}[chunkId] + ".chunk.js";
};